import * as actionTypes from "../actions/actionTypes";
// import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  isDeviceRegistered: false,
  device_token: null,
  uuid: null,
  jwt_token: null,
  isLoggedIn: false,
  profileData: {},
  lastPath: null,
  refreshToken: false,
  SMSSent: false,
  codeVerified: false,
  codeNotVerified: false,
  passwordReset: false,
  signUpSuccess: false,
  signUpFailed: false,
  referral_code: "",
};
var forceAlert = false;
export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.REGISTER_DEVICE_SUCCESS:
      return {
        ...state,
        isDeviceRegistered: true,
        device_token: action.data,
        uuid: action.uuid,
      };
    case actionTypes.REGISTER_DEVICE_FAIL:
      return {
        ...state,
        isDeviceRegistered: false,
        device_token: null,
        uuid: null,
      };

    // Login
    case actionTypes.CONSUMER_LOGIN:
      return {
        ...state,
        jwt_token: null,
      };

    case actionTypes.CONSUMER_LOGIN_SUCCESS:
      forceAlert = false;
      return {
        ...state,
        jwt_token: action.token,
        isLoggedIn: true,
        profileData: action.data,
      };

    case actionTypes.CONSUMER_LOGIN_FAIL:
      return {
        ...state,
        jwt_token: null,
        isLoggedIn: false,
      };

    // Logout
    case actionTypes.CONSUMER_LOGOUT_SUCCESS:
    case actionTypes.CONSUMER_LOGOUT_FAIL:
      return {
        ...state,
        jwt_token: null,
        isLoggedIn: false,
        lastPath: null,
      };

    // Force Logout
    case actionTypes.CONSUMER_FORCE_LOGOUT:
      if (!forceAlert && action.data && action.data !== "") {
        forceAlert = true;
        // 22 sept meeting: remove alert
        // alert(action.data);
      }
      return {
        ...state,
      };
    case actionTypes.CONSUMER_FORCE_LOGOUT_SUCCESS: {
      const lastPath = window.location.pathname;
      return {
        ...state,
        jwt_token: null,
        isLoggedIn: false,
        lastPath: state.lastPath === null ? lastPath : state.lastPath,
      };
    }

    // Redirect Last Path
    case actionTypes.CONSUMER_REDIRECT_LAST_PATH:
      return {
        ...state,
        lastPath: null,
      };

    // Relogin
    case actionTypes.CONSUMER_RELOGIN:
      return {
        ...state,
        refreshToken: false,
      };
    case actionTypes.CONSUMER_RELOGIN_SUCCESS:
      return {
        ...state,
        jwt_token: action.data,
        isLoggedIn: true,
        refreshToken: true,
      };

    case actionTypes.CONSUMER_RELOGIN_FAIL:
      return {
        ...state,
        jwt_token: null,
        isLoggedIn: false,
        refreshToken: true,
      };

    // Send SMS
    case actionTypes.SEND_SMS:
    case actionTypes.SEND_SMS_FAIL:
      return {
        ...state,
        SMSSent: false,
        codeVerified: false,
      };

    case actionTypes.SEND_SMS_SUCCESS:
      return {
        ...state,
        SMSSent: true,
      };

    // Verify SMS
    case actionTypes.VERIFY_SMS:
      return {
        ...state,
        codeVerified: false,
        codeNotVerified: false,
      };

    case actionTypes.VERIFY_SMS_SUCCESS:
      return {
        ...state,
        codeVerified: true,
        codeNotVerified: false,
      };
    case actionTypes.VERIFY_SMS_FAIL:
      return {
        ...state,
        codeVerified: false,
        codeNotVerified: true,
      };

    // Reset Password
    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        SMSSent: false,
        codeVerified: false,
        passwordReset: true,
      };

    case actionTypes.STORE_LOLOL_ID:
      return {
        ...state,
        referral_code: action.data,
      };

    // Sign Up
    case actionTypes.CONSUMER_SIGN_UP:
      return {
        ...state,
        signUpSuccess: false,
        signUpFailed: false,
      };

    case actionTypes.CONSUMER_SIGN_UP_SUCCESS:
      return {
        ...state,
        signUpSuccess: true,
        signUpFailed: false,
        referral_code: "",
      };

    case actionTypes.CONSUMER_SIGN_UP_FAIL:
      return {
        ...state,
        signUpSuccess: false,
        signUpFailed: true,
      };

    // Get Profile Details
    case actionTypes.GET_CONSUMER_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        profileData: action.data,
      };

    case actionTypes.GET_CONSUMER_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        profileData: INITIAL_STATE.profileData,
      };

    // Change Password
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return { ...state };
    default:
      return state;
  }
}
